import React from "react";
import ProductCard from "../../components/common/ProductCard";

const productsData = [
  {
    id: 1,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-1.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 2,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-2.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 3,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-3.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 4,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-4.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 5,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-5.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 6,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-6.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 7,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-1.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 8,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-2.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 9,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-3.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 10,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-4.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 11,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-5.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  {
    id: 12,
    title: "Kesari Phos",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-6.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
  },
  // ... बाकी डेटा यहाँ रखें
];

const ProductsSection = () => {
  return (
    <section className="w-full mt-[51px]">
      <div className="w-full max-w-[1761px] mx-auto px-4 md:px-8 py-[25px] md:py-[37px] lg:py-[50px]">
        <div className="flex flex-col gap-[25px] md:gap-[37px] lg:gap-[50px] items-center">
          <h2 className="text-[30px] md:text-[60px] lg:text-[100px] font-parkinsans font-bold leading-tight text-[#343163] my-[51px]">
            Our Product
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
            {productsData.slice(0, 6).map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
